import { render, staticRenderFns } from "./JobCategoryScoring.vue?vue&type=template&id=0db1aab1&scoped=true"
import script from "./JobCategoryScoring.vue?vue&type=script&setup=true&lang=js"
export * from "./JobCategoryScoring.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobCategoryScoring.vue?vue&type=style&index=0&id=0db1aab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1aab1",
  null
  
)

export default component.exports